// src/components/StepLoader.jsx
import React from "react";
import { useAppStore } from "../store/useAppStore";
import "./StepLoader.css";

const messages = [
  "⚙️ Your app is setting up…",
  "🔄 Connecting to backend API…",
  "📦 Creating app collections…",
  "✍️ Generating engaging content with AI…",
  "🧩 Creating components & pages…",
  "💾 Saving pages…",
  "💾 Saving components…",
  "💾 Saving layouts…",
  "💾 Saving theme…",
  "🎉 Done! Your app is ready!",
];

const StepLoader = () => {
  const { currentStep } = useAppStore();

  if (currentStep === null) return null;

  return (
    <div className="loader-overlay">
      <div className="loader-box">
        <div className="spinner"></div>
        <p className="loader-text">{messages[currentStep]}</p>
      </div>
    </div>
  );
};

// ✅ must be default export
export default StepLoader;

